import { render, staticRenderFns } from "./DeckBrowse.vue?vue&type=template&id=b275d4a6"
import script from "./DeckBrowse.vue?vue&type=script&lang=ts"
export * from "./DeckBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports